import { render, staticRenderFns } from "./BlogInfo.vue?vue&type=template&id=5908316b&scoped=true&"
import script from "./BlogInfo.vue?vue&type=script&lang=js&"
export * from "./BlogInfo.vue?vue&type=script&lang=js&"
import style0 from "./BlogInfo.vue?vue&type=style&index=0&id=5908316b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5908316b",
  null
  
)

export default component.exports